<template>
  <span>
    <h4 class="title-report">Response by Questions Smileys</h4>
    <hr>
    <charts :options="chartOptions"></charts>
  </span>
</template>
<script>

export default {
  props: {
    round_id: {
      type: String,
      required: false
    },
    path: {
      type: String,
      required: false
    },
    dates: {
      type: Object,
      default: function () { return { startDate: 'empty', endDate: 'empty' } },
      required: false,
    }
  },
  data () {
    return {
      data: null,
      chartOptions: {
        chart: {
          type: 'bar'
        },
        title: {
          text: null,
        },
        subtitle: {
          text: null,
        },
        xAxis: {
          categories: []
        },
        yAxis: {
          min: 0,
          title: {
            text: 'Total responses Smileys | Numeral '
          }
        },
        tooltip: {
          shared: true,
          pointFormat: '<span style="color:{series.color}">{point.y} | {series.name}</span>: ({point.percentage:.0f}%)<br/>'
        },
        legend: {
          reversed: true
        },
        plotOptions: {
          series: {
            stacking: 'percent',
          },
        },
        credits: {
          enabled: false
        },
        series: [{
          name: 'Bad',
          data: [],
          color: '#ed3b3b',
        }, {
          name: 'Poor',
          data: [],
          color: '#e87531',
        }, {
          name: 'Average',
          data: [],
          color: '#ffd700',
        }, {
          name: 'Good',
          data: [],
          color: '#407790',  
        }, {
          name: 'Excellent',
          data: [],
          color: '#138315'
        }, {
          name: 'Omitted',
          data: [],
          color: '#CDCDCD'
        }]
      },
    };
  },
  watch: {
    dates: {
      handler: function (val, oldVal) {
        this.loadData();
      },
      deep: true
    },
  },
  mounted () {
    this.loadData();
  },
  methods: {
    loadData: function () {
      let _self = this;
      window.axios.get(`dashboards/round/${this.round_id}/responses-by-smileys/${this.dates.startDate}/${this.dates.endDate}`).then(response => {
        if (response.data.data.byQuestionsId) {
          this.chartOptions.xAxis.categories = response.data.data.questions;
          this.chartOptions.series[0].data = response.data.data.byQuestionsId.Bad;
          this.chartOptions.series[1].data = response.data.data.byQuestionsId.Poor;
          this.chartOptions.series[2].data = response.data.data.byQuestionsId.Average;
          this.chartOptions.series[3].data = response.data.data.byQuestionsId.Good;
          this.chartOptions.series[4].data = response.data.data.byQuestionsId.Excellent;
          this.chartOptions.series[5].data = response.data.data.byQuestionsId.Omitted; 
        }
        this.$emit('endGraphByQuestions');
      });
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/client/rounds/dashboard/graphs/ResponsesByQuestionsSmileys.vue